import React, { createContext, useEffect, useState } from 'react';
import copy from 'copy-to-clipboard';
import { add_setting, get_country_data, get_region_data } from '../Controller/actions';
import { toast } from 'react-toastify';

export const NewContext = createContext();

const NewContextProvider = ({ children }) => {
    // DEFAULT VALUES
    const [token, setToken] = useState(localStorage.getItem('token'));

    // STRINGS
    const [deleteUpdateYes, setDeleteUpdateYes] = useState("");
    const [deleteUpdateTag, setDeleteUpdateTag] = useState("");
    const [search, setSearch] = useState("");
    // const [copyText, setCopyText] = useState("Copy");

    // NUMBERS
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [perPage, setPerPage] = useState(15);

    // BOOLEANS
    const [toggleSidebar, setToggleSidebar] = useState(false);
    const [confirmationModalShow, setConfirmationModalShow] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [validated, setValidated] = useState(false);

    // ARRAYS
    const [currentTableData, setCurrentTableData] = useState([]);
    const [checkedValues, setCheckedValues] = useState([]);
    const [country, setCountry] = useState([]);
    const [region, setRegion] = useState([]);

    // OBJECTS
    const [updatedData, setUpdatedData] = useState({});
    const [deleteUpdateItem, setDeleteUpdateItem] = useState({});
    const [filterDropdown, setFilterDropdown] = useState({
        isAnimated: "",
        isAvaiableDiffKey: "",
        isTop: "",
        isLatest: "",
        isHot: "",
        isActive: "",
        isPremium: "",
    });

    // FUNCTIONS
    const handleCopyData = (_slide) => { copy(JSON.stringify(_slide)) }; // setCopyText("Copied"); setTimeout(() => { setCopyText("Copy") }, 1000)
    const handleFilterChange = (e) => { setFilterDropdown({ ...filterDropdown, [e.target.name]: e.target.value === 'true' ? true : e.target.value === 'false' ? false : "" }) };
    const handleCheckboxChange = (value) => { checkedValues.includes(value) ? setCheckedValues(checkedValues.filter((val) => val !== value)) : setCheckedValues([...checkedValues, value]) };
    const handleSelectAll = (e) => { e.target.checked ? setCheckedValues([...currentTableData.map(_ele => _ele._id)]) : setCheckedValues([]) };
    const handleDeleteAll = async (_deleteUpdateYes) => { setDeleteUpdateYes(_deleteUpdateYes); setDeleteUpdateItem({ id: checkedValues }); setConfirmationModalShow(!confirmationModalShow); };
    const capitalalizeFirstletter = (_str) => _str.charAt(0).toUpperCase() + _str.slice(1)
    const updateStateAryData = (stateAry, fieldAllData, name) => {
        let blankAry = [];
        stateAry?.map(_state => {
            let stateDefaultValue;
            if (name === 'country') {
                stateDefaultValue = fieldAllData?.filter(_field_all => _field_all.code?.toLowerCase() === _state?.toLowerCase())[0];
            } else {
                stateDefaultValue = fieldAllData?.filter(_field_all => _field_all.name.toLowerCase() === _state?.toLowerCase())[0];
            }
            blankAry.push(stateDefaultValue)
        })
        return blankAry?.map(_ele => ({ value: name == 'country' ? _ele.code : _ele.name.toLowerCase(), label: capitalalizeFirstletter(_ele.name), name: name }))
    }
    // const getCountryAndRegionFunc = async (state) => {
    //     try {
    //         const countryData = await get_country_data();
    //         const regionData = await get_region_data();
    //         if (countryData.status && regionData.status) {
    //             countryData.data.map(_ele => setCountry(_prev => [..._prev, { value: _ele.code, label: capitalalizeFirstletter(_ele.name), name: 'country' }]))
    //             regionData.data.map(_ele => setRegion(_prev => [..._prev, { value: _ele.name.toLowerCase(), label: capitalalizeFirstletter(_ele.name), name: 'region' }]))
    //         } else {
    //             toast.error(countryData.message || regionData.message);
    //         }
    //     } catch (error) {
    //         console.error(error);
    //     };
    // };

    const value = {
        //States
        token, setToken,

        deleteUpdateYes, setDeleteUpdateYes,
        deleteUpdateTag, setDeleteUpdateTag,
        search, setSearch,

        currentPage, setCurrentPage,
        totalPage, setTotalPage,
        perPage, setPerPage,

        toggleSidebar, setToggleSidebar,
        confirmationModalShow, setConfirmationModalShow,
        isLoading, setIsLoading,
        validated, setValidated,

        currentTableData, setCurrentTableData,
        checkedValues, setCheckedValues,
        country, setCountry,
        region, setRegion,

        updatedData, setUpdatedData,
        deleteUpdateItem, setDeleteUpdateItem,
        filterDropdown, setFilterDropdown,

        //Functions
        handleCopyData,
        handleFilterChange,
        handleCheckboxChange,
        handleSelectAll,
        handleDeleteAll,
        capitalalizeFirstletter,
        // getCountryAndRegionFunc,
        updateStateAryData,
    };
    return (
        <NewContext.Provider value={value}>
            {children}
        </NewContext.Provider>
    )
};

export default NewContextProvider;